import { render, staticRenderFns } from "./RevertTask.vue?vue&type=template&id=b5daed88"
import script from "./RevertTask.vue?vue&type=script&lang=js"
export * from "./RevertTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports